import { render, staticRenderFns } from "./commonTop.vue?vue&type=template&id=bf7ac9a8&scoped=true"
import script from "./commonTop.vue?vue&type=script&lang=js"
export * from "./commonTop.vue?vue&type=script&lang=js"
import style0 from "./commonTop.vue?vue&type=style&index=0&id=bf7ac9a8&prod&lang=scss&scoped=true"
import style1 from "./commonTop.vue?vue&type=style&index=1&id=bf7ac9a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7ac9a8",
  null
  
)

export default component.exports